export const tags = [
    'PatientID',
    'PatientName',
    'PatientBirthDate',
    'PatientBirthTime',
];
